<template>
    <div class="relative bg-white overflow-hidden">
        <div class="relative">
            <BackgroundVideo />

            <div class="pb-40 lg:pb-32">
                <NavbarSection
                    :sections="sections"
                    :client-portal="clientPortal"
                    :is-sticky="isSticky"
                    ref="navSection"
                />

                <MainSection
                    :is-sticky="isSticky"
                    :client-portal="clientPortal"
                />
            </div>
        </div>

        <div class="relative">
            <ServicesAndSectorsSection :services="services" :items="items" />

            <ShippingSection :shippings="shippings" />

            <AboutSection />

            <ContactSection :contacts="contacts" />

            <FooterSection />
        </div>
    </div>
</template>

<script>
import BackgroundVideo from "@/components/BackgroundVideo";

import NavbarSection from "./sections/NavbarSection";
import MainSection from "./sections/MainSection";
import ServicesAndSectorsSection from "./sections/ServicesAndSectorsSection";
import ShippingSection from "./sections/ShippingSection";
import AboutSection from "./sections/AboutSection";
import ContactSection from "./sections/ContactSection";
import FooterSection from "./sections/FooterSection";

import {
    InboxInIcon,
    CubeTransparentIcon,
    SparklesIcon,
    ShieldExclamationIcon, 
    AtSymbolIcon
} from "@heroicons/vue/outline";

import WhatsappIcon from "@/icons/WhatsappIcon"

export default {
    components: {
        BackgroundVideo,
        NavbarSection,
        MainSection,
        ServicesAndSectorsSection,
        ShippingSection,
        AboutSection,
        ContactSection,
        FooterSection,
    },

    methods: {
        goToElement(id) {
            document.getElementById(id).scrollIntoView({
                behavior: "smooth",
            });
        },
    },

    mounted() {
        window.onscroll = () => {
            if(window.innerWidth < 1024) {
                this.isSticky = false
                return
            }

            if (window.pageYOffset > this.$refs.navSection.$refs.navbar.offsetTop) {
                this.isSticky = true
            } else {
                this.isSticky = false
            }
        }
    },

    data: () => ({
        isSticky: false,

        clientPortal: "http://200.170.248.42:8080/smonet/#/login",

        sections: [
            { name: "Início", id: "main" },
            { name: "Serviços", id: "services-and-sectors" },
            { name: "Nossa Frota", id: "shipping" },
            { name: "Sobre a Empresa", id: "about" },
        ],

        services: [
            {
                name: "Cargas Fracionadas",
                description: "Segurança e Flexibilidade. Nosso time está pronto para atender sua demanda  através de uma das maiores redes de distribuição logística brasileira.  Atendemos mais de 2.600 municípios em 17 Estados Brasileiros.",
                icon: CubeTransparentIcon,
            },
            {
                name: "Carga Lotação (door-to-door)",
                description: "Conduzimos seus produtos com agilidade e segurança. Todas as viagens são monitoradas em tempo real e o foco no nosso time de atendimento ao cliente é garantir a você e sua empresa uma excelente experiência. Conte com a nossa frota de mais de 2.000 veículos.",
                icon: SparklesIcon,
            },
            {
                name: "Armazenagem",
                description:
                    "Aproveite nossos amplos terminais, contamos com galpões para armazenagem de cargas em diversas regiões. Além da gestão de armazenagem, ao escolher a TECMAR você pode contar com uma robusta malha de distribuição para atendimento regional e longa distância.",
                icon: InboxInIcon,
            },
        ],

        items: [
            {
                name: "Auto-peças",
                image: "/img/sectors/car.jpg",
            },
            {
                name: "Cosméticos",
                image: "/img/sectors/cosmetic.jpg",
            },
            {
                name: "Confecção & Calçados",
                image: "/img/sectors/clothing.jpg",
            },
            {
                name: "Alimentos",
                image: "/img/sectors/food.jpg",
            },
            {
                name: "Higiene & Limpeza",
                image: "/img/sectors/cleaning.jpg",
            },
            {
                name: "Armazenagem",
                image: "/img/sectors/storage.jpg",
            },
        ],

        shippings: [
            {
                name: "BiTrem",
                description:
                    "Oferecendo um comprimento máximo de 30 metros, peso de até 74 toneladas e tendo o total de sete eixos. Compoe uma categoria de caminhões que circulam com grandes quantidades de cargas em estradas.",
                explanation:
                    "O bitrem nada mais é que a junção de dois modelos dos tipos de semireboque (a parte de carga) unidos entre si. Essa união acontece por meio de uma espécie de “quinta roda”, que fica localizada no fundo do primeiro veículo que fará a união do conjunto. Todos esses elementos juntos são tracionados por um modelo de cavalo mecânico.",
                image: "/img/shipping/bitrem.webp",
            },
            {
                name: "Truck",
                description:
                    "Com comprimento de 14 metros, o automóvel também possui um melhor desempenho nas estradas. É uma categoria que geralmente não é visto circulando pelas cidades, sendo mais comum nas estradas.",
                explanation:
                    "Conhecido também como trucado ou caminhão 6×2, o caminhão truck possui um conjunto de eixos misto. Sendo um simples (uma roda de cada lado) na frente e outro duplo atrás (duas rodas de cada lado). A configuração permite que o veículo tenha uma capacidade de peso bruto total de 19.5 toneladas. Considerando que o eixo duplo atua diretamente na força do motor.",
                image: "/img/shipping/truck.webp",
            },
            {
                name: "VUC",
                description:
                    "Tendo um comprimento máximo 6,30 metros e peso de até 3 toneladas. Faz parte de uma categoria de caminhões semi-leves e leves que são aptos para entregas urbanas nas regiões centrais das cidades.",
                explanation:
                    "VUC (Veículo Urbano de Carga). Esse é o termo usado para uma categoria de caminhões semi-leves e leves que são aptos para entregas urbanas nas regiões centrais das cidades. Por estas características, eles podem estacionar mais fácil e também possuem permissões especiais que outros caminhões não têm, tendo a capacidade de até 3 toneladas.",
                image: "/img/shipping/vuc.webp",
            },
        ],

        contacts: [
            {
                name: "E-mail",
                hrefName: "comercial@tecmartransportes.com.br",
                href: null,
                description:
                    "Entre em contato com o nosso time comercial via e-mail.",
                icon: AtSymbolIcon,
            },
            {
                name: "WhatsApp",
                hrefName: "Mande uma Mensagem",
                href: "https://web.whatsapp.com/send?phone=5511986156366&text=Ol%C3%A1!%20Acessei%20seu%20site!",
                description: "Converse com nosso time comercial via aplicativo WhatsApp.",
                icon: WhatsappIcon,
            },
            {
                name: "Canal de Denúncia",
                hrefName: "Acesse o Canal",
                href: "https://www.linhaetica.com.br/etica/canaldedenuncialogin",
                description: "Relate descumprimentos do Manual de Conduta Ética no Canal de Denúncia.",
                icon: ShieldExclamationIcon,
            },
        ],
    }),
};
</script>
